import Supplier from "@/features/Supplier/Supplier";
import PlatformDocumentMetadata from "@/features/PlatformDocuments/PlatformDocumentMetadata";
import UploadedPlatformDocumentMetadata from "@/features/PlatformDocuments/UploadedPlatformDocumentMetadata";
import User from "@/shared/models/User";
import SupplierEventProduct from "@/features/SupplierEvents/SupplierEventProduct";
import Note from "@/features/Notes/Note";
import { ExtendedCountry } from "@/features/SupplierEvents/Country";

export enum SupplierEventType {
    PriceEvent,
    SupplyRiskForceMajeure,
    SupplierPlantMaintenance,
    CapacityReduction,
    QualityEvents,
    LogisticsEvent,
    Other,
}
export enum UISupplierEventType {
    // MUST match the above SupplierEventType, this is for displaying human readable values in the UI
    "Price Event",
    "Supply Risk - Force Majeure",
    "Supplier Plant Maintenance",
    "Capacity Reduction",
    "Quality Events",
    "Logistics Event",
    "Other",
}

export enum SupplierEventStatus {
    New,
    InProgress,
    Complete,
}
export enum UISupplierEventStatus {
    // MUST match the above SupplierEventStatusEnum, this is for displaying human readable values in the UI
    "New",
    "In Progress",
    "Complete",
}

export enum SupplierEventPublishedState {
    InProgress,
    Approved,
}
export enum UISupplierEventPublishedState {
    // MUST match the above SupplierEventPublishedState, this is for displaying human readable values in the UI
    "In Progress",
    "Approved",
}

export class ListSupplierEvent {
    id: string = "";
    createdTimestampUTC: Date = new Date();
    submitterName: string = "";
    products: SupplierEventProductName[] = [];
    type: SupplierEventType = null!;
    status: SupplierEventStatus = null!;
    publishedState: SupplierEventPublishedState = null!;
    documentMetadatas: PlatformDocumentMetadata[] = [];
    read: boolean = null!;
}

export default class SupplierEvent {
    id: string = "";
    supplier: Supplier = null!;
    supplierID: string = "";
    createdTimestampUTC: Date = new Date();
    publishedState: SupplierEventPublishedState = null!;
    createdByUser: User | null = null!;
    status: SupplierEventStatus = null!;
    type: SupplierEventType = null!;
    reason: string | null = null;
    comments: string = "";
    countryID: string | null = null;
    country: ExtendedCountry | null = null;
    startDate: Date | null = null;
    endDate: Date | null = null;
    plantLocation: string | null = null;
    leadTimeImpactDays: number | null = null;
    products: SupplierEventProduct[] = [];
    platformDocumentMetadataIDs: string[] = [];
    platformDocumentMetadatas: PlatformDocumentMetadata[] = [];
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] = [];
    notes: Note[] = [];
}

export class SupplierEventProductName {
    supplierProductName: string = "";
    name: string = "";
}
